import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { companyInfo, navLinks } from '../../data/mock';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const [leadData, setLeadData] = useState({
    email: '',
    phone: ''
  });

  const location = useLocation();

  /* ================= SCROLL ================= */
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  /* ================= VISITOR TRACK ================= */
  useEffect(() => {
    fetch("https://teamamtbsolution.com/api/track", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        page: location.pathname,
        email: localStorage.getItem("user_email") || null
      })
    }).catch(() => {});
  }, [location.pathname]);

  /* ================= POPUP ================= */
  useEffect(() => {
    if (!localStorage.getItem("user_email")) {
      setTimeout(() => setShowPopup(true), 4000);
    }
  }, []);

  const handleLeadSubmit = async () => {
    try {
      const res = await fetch("https://teamamtbsolution.com/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: "Website Visitor",
          email: leadData.email,
          phone: leadData.phone,
          message: "Captured from popup"
        })
      });

      if (res.ok) {
        localStorage.setItem("user_email", leadData.email);
        setShowPopup(false);
      }
    } catch {}
  };

  return (
    <>
      {/* ================= POPUP ================= */}
      {showPopup && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4">
          <div className="bg-white p-5 rounded-xl w-[90%] max-w-sm text-center">
            <h3 className="text-lg font-bold mb-2">Get Best Deals 🚀</h3>
            <p className="text-sm text-gray-500 mb-4">
              Enter your details to get instant quotation
            </p>

            <input
              type="email"
              placeholder="Enter Email"
              className="w-full border p-2 rounded mb-2 text-sm"
              value={leadData.email}
              onChange={(e) =>
                setLeadData({ ...leadData, email: e.target.value })
              }
            />

            <input
              type="tel"
              placeholder="Phone (optional)"
              className="w-full border p-2 rounded mb-3 text-sm"
              value={leadData.phone}
              onChange={(e) =>
                setLeadData({ ...leadData, phone: e.target.value })
              }
            />

            <button
              onClick={handleLeadSubmit}
              className="w-full bg-orange-500 text-white py-2 rounded"
            >
              Submit
            </button>
          </div>
        </div>
      )}

      {/* ================= NAVBAR ================= */}
      <nav className={`sticky top-0 z-50 transition ${
        scrolled ? 'bg-white shadow-lg' : 'bg-white'
      }`}>
        <div className="max-w-7xl mx-auto px-4 flex justify-between items-center h-16">

          {/* LOGO */}
          <Link to="/" className="flex items-center gap-2">
            <img src={companyInfo.logo} className="h-10" />
            <h1 className="text-sm md:text-lg font-bold truncate max-w-[120px] md:max-w-none">
              {companyInfo.name}
            </h1>
          </Link>

          {/* DESKTOP */}
          <div className="hidden lg:flex gap-6">
            {navLinks.map((link) => (
              <Link key={link.path} to={link.path}>
                {link.name}
              </Link>
            ))}
          </div>

          <Link
            to="/contact"
            className="hidden lg:block bg-orange-500 text-white px-4 py-2 rounded"
          >
            Contact
          </Link>

          {/* MOBILE BTN */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2"
          >
            {isOpen ? <X /> : <Menu />}
          </button>
        </div>

        {/* ================= MOBILE MENU ================= */}
        <div className={`fixed top-0 left-0 w-full h-full bg-white z-50 transform transition-transform duration-300 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}>
          <div className="flex justify-between items-center p-4 border-b">
            <h2 className="font-bold text-lg">Menu</h2>
            <button onClick={() => setIsOpen(false)}>
              <X />
            </button>
          </div>

          <div className="flex flex-col p-4 space-y-4 text-lg">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className="border-b pb-2"
              >
                {link.name}
              </Link>
            ))}

            <Link
              to="/contact"
              onClick={() => setIsOpen(false)}
              className="bg-orange-500 text-white text-center py-2 rounded"
            >
              Contact
            </Link>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;